import type { DatetimeParams } from '@restore/dynamic-forms';
import { DocumentServiceDatetime } from './types';

export const datetime = (
  datetimeProperties: DocumentServiceDatetime | undefined
): DatetimeParams | undefined => {
  if (!datetimeProperties) {
    return undefined;
  }

  const parsed: DatetimeParams = {
    ...datetimeProperties,
    minDate: datetimeProperties.minDate ? new Date(datetimeProperties.minDate) : undefined,
    maxDate: datetimeProperties.maxDate ? new Date(datetimeProperties.maxDate) : undefined,
  };

  return parsed;
};
